import jquery from 'jquery'
import 'jquery-ui/ui/widgets/slider'
import 'jquery-ui/themes/base/slider.css'
window.jQuery = jquery;
